import styled, { css } from 'styled-components';
import { FONTS, COLORS, SIZE } from '@app/src/ui';

interface Props {
  disabled?: boolean;
  error?: string;
  iconLeft?: boolean;
  isEditable?: boolean;
}

interface PropsIconView {
  disabled?: boolean;
}

export const InputTextWrapper = styled.input`
  outline: none;
  margin: 0;
  border-radius: 4px;
  font-size: 14px;
  font-family: ${FONTS.ROBOTO};
  color: ${COLORS.BLACK};
  box-sizing: border-box;
  width: 100%;
  height: 48px;
  padding: 10px 12px;
  border: 1px solid ${COLORS.GRAY};

  ${(props: Props) => props.iconLeft ? `
    padding: 10px 12px 10px 44px
  `:`
  `}

  &::placeholder {
    color: ${COLORS.GRAY_PLACEHOLDER};
  }
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  & { -moz-appearance:textfield; }
  ${(props:Props) => props.disabled && css`
    pointer-events: none;
  `}
  ${(props:Props) => props.error && css`
    border: 1px solid red;
  `}


  @media (min-width: ${SIZE.TABLET_LANDSCAPE  }) {
    font-size: 16px;
  }
`;

export const ErrorMessage = styled.span`
  color: red;
  font-size: 11px;
`;

export const IconLoading = styled.span`
  position: absolute;
  z-index: 10;
  right: 12px;
  top: 10px;
  svg {
    fill: transparent;
    stroke-width: 5px;
    stroke: #b7b0b0;
    stroke-dasharray: 100%;
    animation: rotate .5s linear infinite
  }

  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const Wrapper = styled.div`
  position: relative;
  border-radius: 6px;
  ${(props:Props) => props.disabled && css`
    cursor: not-allowed;
    opacity: .5;
    background: white;
    & > input {
      opacity: .5;
      background: white;
    }
  `}
  ${(props:Props) => props.isEditable && css`
    border: 1px solid ${COLORS.BLUE_LINK};
  `}
`;

export const IconView = styled.span`
  position: absolute;
  right: 13px;
  top: 11px;
  cursor: pointer;
  
  ${(props:PropsIconView) => props.disabled && css`
    pointer-events: none;
    svg {
      fill: ${COLORS.GRAY_PLACEHOLDER};
    }
  `}
`;
